import card9 from './9.jpg';
import card10 from './10.jpg';
import card11 from './11.jpg';
import card12 from './12.jpg';
import card13 from './13.jpg';
import card48 from './48.jpg';
import card49 from './49.jpg';
import card50 from './50.jpg';
import card51 from './51.jpg';
import card52 from './52.jpg';
import card14 from './14.jpg';
import card15 from './15.jpg';
import card16 from './16.jpg';

const cards_data6 = [
    {
        image:card9,
    },
    {
        image:card10,
    },
    {
        image:card11,
    },
    {
        image:card12,
    },
    {
        image:card13,
    },
    {
        image:card48,
    },
    {
        image:card49,
    },
    {
        image:card50,
    },
    {
        image:card51
    },
    {
        image:card52,
    },
    {
        image:card14,
    },
    {
        image:card15,
    },
    {
        image:card16,
    },
]
export default cards_data6;